window.addEventListener('scroll', () => {
  const bedContainer = document.getElementById('fixedImage');
  const selectionBox = document.getElementById('selectionBox');
  const footer = document.querySelector('footer');
  const bedContainerLocation = bedContainer.getBoundingClientRect();
  const selectionBoxLocation = selectionBox.getBoundingClientRect();
  const footerLocation = footer.getBoundingClientRect();
  if (window.innerWidth > 768) {
    return;
  }
  if (bedContainerLocation.top <= -100) {
    bedContainer.style.position = 'fixed';
    bedContainer.style.top = '0px';
    selectionBox.style.marginTop = '60px';
    selectionBox.style.marginBottom = '20px';
  }
  if (selectionBoxLocation.top >= 200) {
    bedContainer.style.position = 'static';
    selectionBox.style.marginTop = '0px';
    selectionBox.style.marginBottom = '0px';
  }
});

// * Main functions

const activeBed = (e) => {
  if (e.classList.contains('choose-bed')) {
    var el = e;
    el.classList.add('activeBed');
    var siblings = Array.from(el.parentNode.children).filter(function (child) {
      return child !== el;
    });
    siblings.forEach(function (sibling) {
      sibling.classList.remove('activeBed');
    });
  }
  let val = e.children[1].innerHTML.split(' ')[0];
  localStorage.clear();
  localStorage.setItem('bed-size', val);
};
// * Main functions
const changeBedSize = () => {
  let result = confirm('your Selection is removed ?');
  if (result === true) {
    window.location.href = 'https://sleepvillage.co.uk/pages/bed-size';
  }
};
const hideAlert = () => {
  document.getElementById('ModelAlert').style.display = 'none';
};
const ShowAlert = () => {
  document.getElementById('ModelAlert').style.display = 'flex';
};

// * variables used in this page
let intbedSize;
let totalPrice = 0;

let NexBtn = document.getElementById('nextbtn');
var bedPrice = {
  bedFrameShape: {
    hb: 0,
    fb: 0,
  },
  upholestery: {
    hb: 0,
    fb: 0,
  },
  additionFeature: {
    wings: 0,
    bumper: 0,
    wing_beading: 0,
    bumper_beading: 0,
  },
  material: 0,
  pholesteryFinish: 0,
  headboardHeight: 0,
  footboardHeight: 0,
  legs: 0,
  frameSupport: 0,
  underBedLowerFloor: 0,
  mattress: 0,
  ottomanBox: 0,
  SSAssembly: 0,
  disposal: 0,
  delivery: 0,
  matressPockets: 0,
};

// * Function's used in this page

// todo This function is used to check selected bed size if bed size is not available then default bed is 3FT
let checkBedSize = () => {
  let val = localStorage.getItem('bed-size');
  if (val === null || val === undefined) {
    intbedSize = '3FT';
  } else {
    intbedSize = val;
  }
  setIntial();
};
const addToCart = async (data) => {
  let { slectiondata, property } = data;
  let loading = document.getElementById('loading-container');
  loading.style.display = 'flex';
  let price = parseFloat(document.getElementById('DiscountedPrice')?.innerHTML?.split('£')[1]);
  const bedSize = localStorage.getItem('bed-size') || '3FT';

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },

    body: JSON.stringify({
      data: slectiondata,
      price,
      property,
      bedSize,
    }), // Convert the data to JSON format
  };
  fetch('https://sleepvillage-hei7.onrender.com/', options)
    .then((response) => {
      if (!response.ok) {
        loading.style.display = 'none';
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((responseData) => {
      let formObj = responseData.data;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formObj),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          window.location.href = 'https://sleepvillage.co.uk/cart';
          loading.style.display = 'none';
        })
        .catch((error) => {
          loading.style.display = 'flex';
        });
    })
    .catch((error) => {
      // console.error("Error:", error);
      loading.style.display = 'flex';
    });
};
// todo this function is created for handling the price
let Pcount = 0;
let handlePrice = () => {
  let prevprice = JSON.parse(localStorage.getItem('userSel'))?.bedPrice;
  if (prevprice && Pcount == 0) {
    bedPrice = prevprice;
    Pcount = 1;
  }
  let {
    bedFrameShape,
    upholestery,
    additionFeature,
    material,
    pholesteryFinish,
    headboardHeight,
    footboardHeight,
    legs,
    frameSupport,
    underBedLowerFloor,
    mattress,
    ottomanBox,
    SSAssembly,
    disposal,
    matressPockets,
  } = bedPrice;

  let semifinal =
    bedFrameShape.hb +
    bedFrameShape.fb +
    upholestery.hb +
    upholestery.fb +
    additionFeature.wings +
    additionFeature.bumper +
    additionFeature.wing_beading +
    additionFeature.bumper_beading +
    material +
    pholesteryFinish +
    headboardHeight +
    footboardHeight +
    legs +
    frameSupport +
    underBedLowerFloor +
    mattress +
    ottomanBox +
    SSAssembly +
    disposal +
    matressPockets;

  let mainPriceText = document.getElementById('main-price');
  let discountedPriceText = document.getElementById('DiscountedPrice');
  // const totalValue = semifinal + totalPrice;
  // const finalPrice = +(totalValue - (totalValue * discount) / 100).toFixed(2);

  //* Use this to only apply discount on bed price not apply discount on option
  const totalValue = semifinal + totalPrice;
  const discountedValue = (totalPrice * discount) / 100;

  const finalPrice = (totalValue - discountedValue).toFixed(2);

  mainPriceText.innerHTML = `£ ${totalValue.toFixed(2)}`;
  discountedPriceText.innerHTML = `£ ${finalPrice}`;
};

// todo This function is used to handle next button on the page
const nextButtonClick = (e) => {
  const slectiondata = {
    'BedFrame Shape Headboard': {
      option: bedOption.bedFrameShape.hb,
      price: bedPrice.bedFrameShape.hb,
    },
    'BedFrame Shape Footboard': {
      option: bedOption.bedFrameShape.fb,
      price: bedPrice.bedFrameShape.fb,
    },
    'Upholestery Design Headboard': {
      option: bedOption.upholestery.hb,
      price: bedPrice.upholestery.hb,
    },
    'Upholestery Design Footboard': {
      option: bedOption.upholestery.fb,
      price: bedPrice.upholestery.fb,
    },
    'Headboard Wings': {
      option: bedOption.additionFeature.wings,
      price: bedPrice.additionFeature.wings,
    },
    'Headboard Bumper': {
      option: bedOption.additionFeature.bumper,
      price: bedPrice.additionFeature.bumper,
    },
    Material: {
      option: bedOption.material,
      price: bedPrice.material,
    },
    'Pholestery Finish': {
      option: bedOption.pholesteryFinish,
      price: bedPrice.pholesteryFinish,
    },
    'Headboard Height': {
      option: bedOption.headboardHeight,
      price: bedPrice.headboardHeight,
    },
    'Footboard Height': {
      option: bedOption.footboardHeight,
      price: bedPrice.footboardHeight,
    },
    Legs: {
      option: bedOption.legs,
      price: bedPrice.legs,
    },
    'Frame Support': {
      option: bedOption.frameSupport,
      price: bedPrice.frameSupport,
    },
    'UnderBed Lower Floor': {
      option: bedOption.underBedLowerFloor,
      price: bedPrice.underBedLowerFloor,
    },
    Mattress: {
      option: bedOption.mattress,
      price: bedPrice.mattress,
    },
    'Ottoman Box': {
      option: bedOption.ottomanBox,
      price: bedPrice.ottomanBox,
    },
    'Special Assembly': {
      option: bedOption.SSAssembly,
      price: bedPrice.SSAssembly,
    },
    Disposal: {
      option: bedOption.disposal,
      price: bedPrice.disposal,
    },
    Delivery: {
      option: bedOption.delivery,
      price: bedPrice.delivery,
    },
  };

  const property = {
    'Headboard Shape': bedOption.bedFrameShape.hb,
    'Footboard Shape': bedOption.bedFrameShape.fb,
    'Headboard Design': bedOption.upholestery.hb,
    'Footboard Design': bedOption.upholestery.fb,
    'Headboard Wings': bedOption.additionFeature.wings,
    'Headboard Bumper': bedOption.additionFeature.bumper,
    Material: bedOption.material,

    'Headboard Height': bedOption.headboardHeight,
    'Footboard Height': bedOption.footboardHeight,
    Legs: bedOption.legs,
    'Frame Support': bedOption.frameSupport,
    'UnderBed Lower Floor': bedOption.underBedLowerFloor,
    Mattress: bedOption.mattress,
    'Ottoman Box': bedOption.ottomanBox,
    'Special Assembly': bedOption.SSAssembly,
    Disposal: bedOption.disposal,
    Delivery: bedOption.delivery,
  };
  if (viewupholestery()) {
    property['Upholstery Details'] = bedOption.pholesteryFinish;
  }

  // if (!bedOption.mattress.includes("Orthopaedic") && !bedOption.mattress.includes("Not")) {
  //   console.log("work");
  //   slectiondata["Matress Pockets"] = {
  //     option: bedOption.matressPockets,
  //     price: bedPrice.matressPockets,
  //   };
  //   property[
  //     "Matress Pockets"
  //   ] = bedOption.matressPockets
  // } else {
  //   if (property["Matress Pockets"]) {
  //     delete property["Matress Pockets"];
  //     delete slectiondata["Matress Pockets"];
  //   }
  // }
  if (bedOption.additionFeature.wing_beading) {
    slectiondata['Headboard Wings Beading'] = {
      option: `${bedOption.additionFeature.wing_beading} required`,
      price: bedPrice.additionFeature.wing_beading,
    };
    property['Headboard Wings Beading'] = `${bedOption.additionFeature.wing_beading} required`;
  } else {
    if (property['Headboard Wings Beading']) {
      delete property['Headboard Wings Beading'];
      delete slectiondata['Headboard Wings Beading'];
    }
  }

  if (bedOption.additionFeature.bumper_beading) {
    slectiondata['Headboard Bumper Beading'] = {
      option: `${bedOption.additionFeature.bumper_beading} required`,
      price: bedPrice.additionFeature.bumper_beading,
    };
    property['Headboard Bumper Beading'] = `${bedOption.additionFeature.bumper_beading} Required`;
  } else {
    if (property['Headboard Bumper Beading']) {
      delete property['Headboard Bumper Beading'];
      delete slectiondata['Headboard Bumper Beading'];
    }
  }
  let nextbtn = document.getElementById('nextbtn');
  if (e.innerHTML.includes('Enquiry') && nextbtn) {
    localStorage.setItem('createdbed', JSON.stringify(slectiondata));
    window.location.href = 'https://sleepvillage.co.uk/pages/bed-enquiry';
  }
  if (e.innerHTML.includes('Checkout') && nextbtn) {
    nextbtn.disabled = true;
    addToCart({ slectiondata, property });
  }

  let click = e.id;
  var bedbox = document.getElementById('build-own-bed');
  if (bedbox && nextbtn) {
    bedbox.scrollIntoView({ behavior: 'smooth' });
  }
  var step1 = document.getElementById('step-1-tab');
  var step2 = document.getElementById('step-2-tab');
  var step3 = document.getElementById('step-4-tab');
  var step4 = document.getElementById('step-5-tab');
  let arr = [step1, step2, step3, step4];
  var step1Container = document.getElementById('step-1');
  var step2Container = document.getElementById('step-2');
  var step3Container = document.getElementById('step-4');
  var step4Container = document.getElementById('step-5');
  let checkActive = () => {
    let check;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].classList.contains('active')) {
        check = arr[i];
      }
    }
    return check;
  };
  let activeStep = checkActive().id;
  if (click === 'step-1-tab') {
    nextbtn.innerHTML = ' Next';
  }
  if (click === 'step-2-tab') {
    nextbtn.innerHTML = ' Next';
  }
  if (click === 'step-4-tab') {
    nextbtn.innerHTML = ' Next';
  }
  if (click === 'step-5-tab') {
    let ct = document.getElementById('customTxt').innerHTML;
    if (ct) {
      nextbtn.innerHTML = ' Send Enquiry';
    } else {
      nextbtn.innerHTML = ' Checkout';
    }
  }

  if (!e.classList.contains('nav-link')) {
    if (activeStep === 'step-1-tab') {
      step2.classList.add('active');
      step2Container.classList.add('active', 'show');
      step1.classList.remove('active');
      step1Container.classList.remove('active', 'show');
      nextbtn.innerHTML = ' Next';
    }
    if (activeStep === 'step-2-tab') {
      step3.classList.add('active');
      step3Container.classList.add('active', 'show');
      step2.classList.remove('active');
      step2Container.classList.remove('active', 'show');
      nextbtn.innerHTML = ' Next';
    }
    if (activeStep === 'step-4-tab') {
      step4.classList.add('active');
      step4Container.classList.add('active', 'show');
      step3.classList.remove('active');
      step3Container.classList.remove('active', 'show');
      let ct = document.getElementById('customTxt').innerHTML;
      if (ct) {
        nextbtn.innerHTML = ' Send Enquiry';
      } else {
        nextbtn.innerHTML = ' Checkout';
      }
    }
  }

  // if (step4Container.classList.contains("show") && click === "nextbtn") {
  //   console.log(slectiondata);
  // }
};

// todo this function is created for setting the intial price of bed according to selected bed
let setIntial = () => {
  switch (intbedSize) {
    case '3FT':
      totalPrice = 499.99;
      break;
    case '4FT':
      totalPrice = 634.99;
      break;
    case '4FT6':
      totalPrice = 669.99;
      break;
    case '5FT':
      totalPrice = 749.99;
      break;
    case '6FT':
      totalPrice = 919.99;
      break;
    default:
      totalPrice = NaN;
      break;
  }
  let tag = document.getElementById('main-price');
  // let tag1 = document.getElementById("main-mb-price");
  let dicsp = document.getElementById('DiscountedPrice');
  let dicsper = document.getElementById('DiscountPer');
  let p = (totalPrice - (totalPrice * discount) / 100).toFixed(2);
  tag.innerHTML = `£ ${totalPrice}`;
  // tag1.innerHTML = `£ ${totalPrice}`;
  dicsp.innerHTML = `£ ${p}`;
  dicsper.innerHTML = `${discount}`;
  handlePrice();
};

// todo This function is created for view upholestery
const viewupholestery = () => {
  let view = document.getElementById('upholesteryFinish');
  let head = bedOption.upholestery.hb.includes('Chester');
  let cube = bedOption.upholestery.hb.includes('Cube');
  let cubeF = bedOption.upholestery.fb.includes('Cube');
  let chesterF = bedOption.upholestery.fb.includes('Chester');
  if (head || cube || cubeF || chesterF) {
    view.classList.remove('d-none');
  } else {
    if (!view.classList.contains('d-none')) {
      view.classList.add('d-none');
    }
  }
  return head || cube || cubeF || chesterF;
};

// todo This function is handle matching select in bedframe and upholestery
let handlePair = (ele) => {
  if (ele.classList.contains('bedFrameShape')) {
    let bedframdata = document.getElementsByClassName('bedFrameShape');
    let val = ele.id;
    for (let i = 0; i < bedframdata.length; i++) {
      if (bedframdata[i].id === val) {
        bedframdata[i].classList.add('selected');
        bedframdata[i].childNodes[5].classList.add('active');
        if (bedframdata[i].classList.contains('headboard')) {
          document.getElementById('bedFrameShape-headboard').innerHTML = ele.children[1].innerText;
          let price = parseFloat(bedframdata[i].childNodes[5].innerHTML.split(' ')[1]);
          if (isNaN(price)) {
            price = 0;
          }
          bedOption.bedFrameShape.hb = val;
          bedPrice.bedFrameShape.hb = price;
        }
        if (bedframdata[i].classList.contains('footboard')) {
          document.getElementById('bedFrameShape-footboard').innerHTML = ele.children[1].innerText;
          let price = parseFloat(bedframdata[i].childNodes[5].innerHTML.split(' ')[1]);
          if (isNaN(price)) {
            price = 0;
          }
          bedOption.bedFrameShape.fb = val;
          bedPrice.bedFrameShape.fb = price;
        }
      } else {
        bedframdata[i].classList.remove('selected');
        bedframdata[i].childNodes[5].classList.remove('active');
      }
    }
  } else if (ele.classList.contains('upholstery')) {
    let upholesterydata = document.getElementsByClassName('upholstery');
    let val = ele.id;
    for (let i = 0; i < upholesterydata.length; i++) {
      if (upholesterydata[i].id === val) {
        upholesterydata[i].classList.add('selected');
        upholesterydata[i].childNodes[5].classList.add('active');
        if (upholesterydata[i].classList.contains('headboard')) {
          document.getElementById('upholsteryHeadboard').innerHTML = ele.children[1].innerText;
          let price = parseFloat(upholesterydata[i].childNodes[5].innerHTML.split(' ')[1]);
          bedOption.upholestery.hb = val;
          bedPrice.upholestery.hb = price;
        }
        if (upholesterydata[i].classList.contains('footboard')) {
          document.getElementById('upholsteryFootboard').innerHTML = ele.children[1].innerText;
          let price = parseFloat(upholesterydata[i].childNodes[5].innerHTML.split(' ')[1]);
          bedOption.upholestery.fb = val;
          bedPrice.upholestery.fb = price;
        }
      } else {
        upholesterydata[i].classList.remove('selected');
        upholesterydata[i].childNodes[5].classList.remove('active');
      }
    }
  }
};

// todo This function is handle custom option
const handleQuery = (e) => {
  let hbh = bedOption.headboardHeight.includes('Custom');
  let fbh = bedOption.footboardHeight.includes('Custom');
  let ele = e.childNodes[3].innerHTML.includes('Custom');
  let ct = document.getElementById('customTxt');
  if (hbh) {
    ct.innerHTML = '+ Custom Enquiry';
  } else if (fbh) {
    ct.innerHTML = '+ Custom Enquiry';
  } else if (ele) {
    ct.innerHTML = '+ Custom Enquiry';
  } else {
    ct.innerHTML = '';
  }
};

// todo This function is handle beading show and hide on chesterfield select in uphpolestery
let handlebeading = (e) => {
  const bbt = document.getElementById('bbt');
  const wbt = document.getElementById('wbt');
  let a = e.classList.contains('selected');
  let b = e.classList.contains('beading-wing-opt');
  let c = e.classList.contains('beading-bumper-opt');
  let d = e.children[2].classList.contains('active');
  let f = document.getElementById('wing-text');
  let g = document.getElementById('bumper-text');
  let price = parseFloat(e.children[2].innerHTML.split('£')[1]);

  if (!a) {
    e.classList.add('selected');
    e.children[2].classList.add('active');
  } else {
    e.classList.remove('selected');
    e.children[2].classList.remove('active');
  }
  if (b) {
    if (!d) {
      bedPrice.additionFeature.wing_beading = price;
      bedOption.additionFeature.wing_beading = wbt.innerHTML;
      f.classList.remove('d-none');
    } else {
      f.classList.add('d-none');
      bedOption.additionFeature.wing_beading = '';
      bedPrice.additionFeature.wing_beading = 0;
    }
  }
  if (c) {
    if (!d) {
      bedPrice.additionFeature.bumper_beading = price;
      bedOption.additionFeature.bumper_beading = bbt.innerHTML;
      g.classList.remove('d-none');
    } else {
      bedPrice.additionFeature.bumper_beading = 0;
      bedOption.additionFeature.bumper_beading = '';
      g.classList.add('d-none');
    }
  }
  handlePrice();
  localStorage.setItem('userSel', JSON.stringify({ bedOption, bedPrice }));
};

//todo this is created to render element with the help of javascript
const handleview = (e) => {
  let bedSize = intbedSize;
  let {
    bedFrameShape,
    upholestery,
    additionFeature,
    material,
    pholesteryFinish,
    headboardHeight,
    footboardHeight,
    legs,
    frameSupport,
    underBedLowerFloor,
    mattress,
    ottomanBox,
    SSAssembly,
    disposal,
    delivery,
    matressPockets,
  } = bedData;
  // * step1 bedframe
  let shapeHB = document.getElementById('bedframeHeadboard');
  let shapeFB = document.getElementById('bedframeFB');
  // * step1 upholestery
  let upholesteryHB = document.getElementById('upholesteryhb');
  let upholesteryFB = document.getElementById('upholesteryfb');
  // * step1 additional feature
  let wings = document.getElementById('featurewing');
  let bumper = document.getElementById('featurebumper');
  // * step1 Material
  let MatChenille = document.getElementById('matChenille');
  let MatConiston = document.getElementById('matConiston');
  let MatCrushed = document.getElementById('matCrushed');
  let MatGreek = document.getElementById('matGreek');
  let MatLinen = document.getElementById('matLinen');
  let MatNaples = document.getElementById('matNaples');
  let MatPlush = document.getElementById('matPlush');
  let MatSuede = document.getElementById('matSuede');
  let MatWool = document.getElementById('matWool');
  let MatLeather = document.getElementById('matLeather');
  // * step1 Material
  let pholesteryFinishD = document.getElementById('pholesteryFinish');
  // * step2 headboardHeight
  let headboardHeightD = document.getElementById('headboardHeightM');
  // * step2 footboardHeight
  let footboardHeightD = document.getElementById('footboardHeightM');
  // * step2 frameSupport
  let frameSupportD = document.getElementById('frameSupportM');
  // * step2 underBedLowerFloor
  let underBedLowerFloorD = document.getElementById('underBedLowerFloorM');
  // * step2 Matress
  let mattressD = document.getElementById('matressM');
  // * step2 pocket
  let matressPocketsD = document.getElementById('pockets');
  // * step2 ottomanBox
  let ottomanBoxD = document.getElementById('ottomanBoxM');
  // * step2 SSAssembly
  let SSAssemblyD = document.getElementById('SSAssemblyM');
  // * step2 ottomanBox
  let disposalD = document.getElementById('disposalM');
  // * step2 ottomanBox
  let deliveryD = document.getElementById('deliveryM');
  // * step2 legs
  let legsD = document.getElementById('legsM');

  if (shapeHB) {
    // * HTML created for shapeHB
    var shapeHBtext = bedFrameShape.hb.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
    class='dropdown_item bedFrameShape headboard ${bedOption.bedFrameShape.hb === item.text ? 'selected' : ''}'>      
      <img class='iconSize' src=${item.url} alt=''/>     
       <p>${item.text}</p>
       ${
         bedSize == '3FT'
           ? `<p class='price ${bedOption.bedFrameShape.hb === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
           : ''
       }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.bedFrameShape.hb === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.bedFrameShape.hb === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.bedFrameShape.hb === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.bedFrameShape.hb === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
           : ''
       } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }    
    </div>`;
    });
    shapeHB.innerHTML = shapeHBtext.join('');
    // * HTML created for shapeFB
    var shapeFBtext = bedFrameShape.fb.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
    class='dropdown_item bedFrameShape footboard ${bedOption.bedFrameShape.fb === item.text ? 'selected' : ''}'>      
    <img class='iconSize' src=${item.url} alt=''/>     
     <p>${item.text}</p>
     ${
       bedSize == '3FT'
         ? `<p class='price ${bedOption.bedFrameShape.fb === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
         : ''
     }   
     ${
       bedSize == '4FT'
         ? `<p class='price ${bedOption.bedFrameShape.fb === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
         : ''
     }   
     ${
       bedSize == '4FT6'
         ? `<p class='price ${bedOption.bedFrameShape.fb === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
         : ''
     }   
     ${
       bedSize == '5FT'
         ? `<p class='price ${bedOption.bedFrameShape.fb === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
         : ''
     }   
     ${
       bedSize == '6FT'
         ? `<p class='price ${bedOption.bedFrameShape.fb === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
         : ''
     } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    shapeFB.innerHTML = shapeFBtext.join('');
  }
  if (upholesteryHB && upholesteryFB) {
    // * HTML created for upholesteryHB
    var upholesteryHBtext = upholestery.hb.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item upholstery headboard ${bedOption.upholestery.hb === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.upholestery.hb === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.upholestery.hb === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.upholestery.hb === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.upholestery.hb === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.upholestery.hb === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }    
        </div>`;
    });
    upholesteryHB.innerHTML = upholesteryHBtext.join('');
    // * HTML created for upholesteryFB
    var upholesteryFBtext = upholestery.fb.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item upholstery footboard ${bedOption.upholestery.fb === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.upholestery.fb === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.upholestery.fb === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.upholestery.fb === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.upholestery.fb === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.upholestery.fb === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    upholesteryFB.innerHTML = upholesteryFBtext.join('');
  }
  if (wings && bumper) {
    // * HTML created for additionFeaturewing
    var additionFeaturewingtext = additionFeature.wings.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item feature-opt wings ${bedOption.additionFeature.wings === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.additionFeature.wings === item.text ? 'active' : ''}'>£ ${
                 item.threeft == 0 ? ' 0.00' : +item.threeft
               } </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.additionFeature.wings === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.additionFeature.wings === item.text ? 'active' : ''}'>£ ${
                 item.fourftSix == 0 ? '0.00' : item.fourftSix
               }</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.additionFeature.wings === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.additionFeature.wings === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    wings.innerHTML = additionFeaturewingtext.join('');
    // * HTML created for additionFeatureBumper
    var additionFeatureBumpertext = additionFeature.bumper.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item feature-opt bumper ${bedOption.additionFeature.bumper === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.additionFeature.bumper === item.text ? 'active' : ''}'>£ ${
                 item.threeft == 0 ? ' 0.00' : +item.threeft
               } </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.additionFeature.bumper === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.additionFeature.bumper === item.text ? 'active' : ''}'>£ ${
                 item.fourftSix == 0 ? '0.00' : item.fourftSix
               }</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.additionFeature.bumper === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.additionFeature.bumper === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    bumper.innerHTML = additionFeatureBumpertext.join('');
  }
  if (MatChenille) {
    // * HTML created for MatChenille
    var MatChenilletext = material.Chenille.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Chenillecolor${i + 1}     
        class='dropdown_item material-opt ${
          bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'selected' : ''
        }'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Chenille') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    MatChenille.innerHTML = MatChenilletext.join('');

    // * HTML created for MatConiston
    var MatConistontext = material.Coniston.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Conistoncolor${i + 1}     
        class='dropdown_item material-opt ${
          bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'selected' : ''
        }'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Coniston') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    MatConiston.innerHTML = MatConistontext.join('');

    // * HTML created for MatCrushed
    var MatCrushedtext = material.Crushed.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Crushedcolor${i + 1}     
        class='dropdown_item material-opt ${
          bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'selected' : ''
        }'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Crushed') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    MatCrushed.innerHTML = MatCrushedtext.join('');

    // * HTML created for MatGreek
    var MatGreektext = material.Greek.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Mysticcolor${i + 1}     
        class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Mystic') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    MatGreek.innerHTML = MatGreektext.join('');

    // * HTML created for MatLinen
    var MatLinentext = material.Linen.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Linencolor${i + 1}     
    class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Linen') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    MatLinen.innerHTML = MatLinentext.join('');

    // * HTML created for MatNaples
    var MatNaplestext = material.Naples.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Naplescolor${i + 1}     
    class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Naples') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    MatNaples.innerHTML = MatNaplestext.join('');

    // * HTML created for MatPlush
    var MatPlushtext = material.Plush.map((item, i) => {
      // console.log(bedOption.material.includes("Silver Pebble"))
      return `<div onclick='hanldleSelectOption(this)' id=Plushcolor${i + 1}     
    class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'selected' : ''}'>      
    <img class='iconSize' src=${item.url} alt=''/>     
     <p>${item.text}</p>
     ${
       bedSize == '3FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'active' : ''}'>£ ${
             item.threeft == 0 ? ' 0.00' : +item.threeft
           } </p>`
         : ''
     }   
     ${
       bedSize == '4FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'active' : ''}'>£ ${
             item.fourft == 0 ? '0.00' : item.fourft
           }</p>`
         : ''
     }   
     ${
       bedSize == '4FT6'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'active' : ''}'>£ ${
             item.fourftSix == 0 ? '0.00' : item.fourftSix
           }</p>`
         : ''
     }   
     ${
       bedSize == '5FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'active' : ''}'>£ ${
             item.fiveft == 0 ? '0.00' : item.fiveft
           }</p>`
         : ''
     }   
     ${
       bedSize == '6FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Plush') ? 'active' : ''}'>£ ${
             item.sixft == 0 ? '0.00' : item.sixft
           }</p>`
         : ''
     } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    MatPlush.innerHTML = MatPlushtext.join('');

    // * HTML created for MatSuede
    var MatSuedetext = material.Suede.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Suedecolor${i + 1}     
    class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Suede') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    MatSuede.innerHTML = MatSuedetext.join('');

    // * HTML created for MatWool
    var MatWooltext = material.Wool.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Woolcolor${i + 1}     
    class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'active' : ''}'>£ ${
                   item.threeft == 0 ? ' 0.00' : +item.threeft
                 } </p>`
               : ''
           }   
       ${
         bedSize == '4FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'active' : ''}'>£ ${
               item.fourft == 0 ? '0.00' : item.fourft
             }</p>`
           : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'active' : ''}'>£ ${
               item.fourftSix == 0 ? '0.00' : item.fourftSix
             }</p>`
           : ''
       }   
       ${
         bedSize == '5FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'active' : ''}'>£ ${
               item.fiveft == 0 ? '0.00' : item.fiveft
             }</p>`
           : ''
       }   
       ${
         bedSize == '6FT'
           ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Wool') ? 'active' : ''}'>£ ${
               item.sixft == 0 ? '0.00' : item.sixft
             }</p>`
           : ''
       }  
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
    </div>`;
    });
    MatWool.innerHTML = MatWooltext.join('');

    // * HTML created for MatLeather
    var MatLeathertext = material.Leather.map((item, i) => {
      return `<div onclick='hanldleSelectOption(this)' id=Leathercolor${i + 1}     
      class='dropdown_item material-opt ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>   
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'active' : ''}'>£ ${
                 item.threeft == 0 ? ' 0.00' : +item.threeft
               } </p>`
             : ''
         }   
     ${
       bedSize == '4FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'active' : ''}'>£ ${
             item.fourft == 0 ? '0.00' : item.fourft
           }</p>`
         : ''
     }   
     ${
       bedSize == '4FT6'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'active' : ''}'>£ ${
             item.fourftSix == 0 ? '0.00' : item.fourftSix
           }</p>`
         : ''
     }   
     ${
       bedSize == '5FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'active' : ''}'>£ ${
             item.fiveft == 0 ? '0.00' : item.fiveft
           }</p>`
         : ''
     }   
     ${
       bedSize == '6FT'
         ? `<p class='price ${bedOption.material.includes(item.text) && bedOption.material.includes('Leather') ? 'active' : ''}'>£ ${
             item.sixft == 0 ? '0.00' : item.sixft
           }</p>`
         : ''
     }
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
      </div>`;
    });
    MatLeather.innerHTML = MatLeathertext.join('');
  }
  if (pholesteryFinishD) {
    // * HTML created for pholesteryFinish
    var pholesteryFinishDtext = pholesteryFinish.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item pholestery ${bedOption.pholesteryFinish === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.pholesteryFinish === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.pholesteryFinish === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.pholesteryFinish === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.pholesteryFinish === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.pholesteryFinish === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    pholesteryFinishD.innerHTML = pholesteryFinishDtext.join('');
  }
  if (headboardHeightD) {
    // * HTML created for headboardHeight
    var headboardHeightDtext = headboardHeight.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item headboardHeight ${bedOption.headboardHeight === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.headboardHeight === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.headboardHeight === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.headboardHeight === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.headboardHeight === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.headboardHeight === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    headboardHeightD.innerHTML = headboardHeightDtext.join('');
  }
  if (footboardHeightD) {
    // * HTML created for footboardHeight
    var footboardHeightDtext = footboardHeight.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item footboardHeight ${bedOption.footboardHeight === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.footboardHeight === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.footboardHeight === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.footboardHeight === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.footboardHeight === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.footboardHeight === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    footboardHeightD.innerHTML = footboardHeightDtext.join('');
  }
  if (legsD) {
    // * HTML created for legs
    var metal_legstext = legs.metal_legs
      .map((item) => {
        return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item legs-opt ${bedOption.legs === item.text ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
               : ''
           }   
       ${
         bedSize == '4FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>` : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
           : ''
       }   
       ${
         bedSize == '5FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>` : ''
       }   
       ${bedSize == '6FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>` : ''}${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }    
        </div>`;
      })
      .join('');

    var wooden_legstext = legs.wooden_legs
      .map((item) => {
        return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item legs-opt ${bedOption.legs === item.text ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
               : ''
           }   
       ${
         bedSize == '4FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>` : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
           : ''
       }   
       ${
         bedSize == '5FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>` : ''
       }   
       ${bedSize == '6FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>` : ''}${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }    
        </div>`;
      })
      .join('');
    var wooden_legs_nickeltext = legs.wooden_legs_nickel
      .map((item) => {
        return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item legs-opt ${bedOption.legs === item.text ? 'selected' : ''}'>      
          <img class='iconSize' src=${item.url} alt=''/>     
           <p>${item.text}</p>   
           ${
             bedSize == '3FT'
               ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
               : ''
           }   
       ${
         bedSize == '4FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>` : ''
       }   
       ${
         bedSize == '4FT6'
           ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
           : ''
       }   
       ${
         bedSize == '5FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>` : ''
       }   
       ${bedSize == '6FT' ? `<p class='price ${bedOption.legs === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>` : ''}${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }    
        </div>`;
      })
      .join('');
    const data = `<div onclick="hanldleSelectOption(this)"
    class="dropdown_item legs-opt ${bedOption.legs === 'No Legs' ? 'selected' : ''}" id="no-legs">
    <img class="iconSize legs-opt p-3"
            src="https://cdn.shopify.com/s/files/1/0518/2157/6345/t/34/assets/traffic-signal.png"
            alt="" />
    <p>No Legs</p>
    <p class='price ${bedOption.legs === 'No Legs' ? 'active' : ''}'>0.00</p>
</div>
<h5 class="w-100 m-0">Metal Legs</h5>
${metal_legstext}
<h5 class="w-100 m-0">Wooden Legs</h5>
${wooden_legstext}
<h5 class="w-100 m-0">Wooden Legs With Silver Nickel</h5>
${wooden_legs_nickeltext}
`;

    legsD.innerHTML = data;
  }
  if (frameSupportD) {
    // * HTML created for frameSupport
    var frameSupportDtext = frameSupport.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item storage-opt ${bedOption.frameSupport === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.frameSupport === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.frameSupport === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.frameSupport === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.frameSupport === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.frameSupport === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    frameSupportD.innerHTML = frameSupportDtext.join('');
  }
  if (underBedLowerFloorD) {
    // * HTML created for underBedLowerFloor
    var underBedLowerFloorDtext = underBedLowerFloor.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item underBedLowerFloor-opt ${bedOption.underBedLowerFloor === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.underBedLowerFloor === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.underBedLowerFloor === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.underBedLowerFloor === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.underBedLowerFloor === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.underBedLowerFloor === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    underBedLowerFloorD.innerHTML = underBedLowerFloorDtext.join('');
  }
  if (mattressD) {
    // * HTML created for mattress
    var mattressDtext = mattress.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item mattress-opt ${bedOption.mattress.includes(item.text) ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.mattress.includes(item.text) ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.mattress.includes(item.text) ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.mattress.includes(item.text) ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.mattress.includes(item.text) ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.mattress.includes(item.text) ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    mattressD.innerHTML = mattressDtext.join('');
  }
  if (matressPocketsD) {
    // * HTML created for matressPockets
    var matressPocketsDtext = matressPockets.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item pockets-opt mattress-opt ${bedOption.matressPockets.includes(item.text) ? 'selected' : ''}''>      
          <img class='iconSize' src=${item.url} alt=''/>     
          <p>${item.text}</p>
          ${
            bedSize == '3FT'
              ? `<p class='price ${bedOption.matressPockets.includes(item.text) ? 'active' : ''}'>£ ${
                  item.threeft == 0 ? ' 0.00' : +item.threeft
                } </p>`
              : ''
          }   
          ${
            bedSize == '4FT'
              ? `<p class='price ${bedOption.matressPockets.includes(item.text) ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
              : ''
          }   
          ${
            bedSize == '4FT6'
              ? `<p class='price ${bedOption.matressPockets.includes(item.text) ? 'active' : ''}'>£ ${
                  item.fourftSix == 0 ? '0.00' : item.fourftSix
                }</p>`
              : ''
          }   
          ${
            bedSize == '5FT'
              ? `<p class='price ${bedOption.matressPockets.includes(item.text) ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
              : ''
          }   
          ${
            bedSize == '6FT'
              ? `<p class='price ${bedOption.matressPockets.includes(item.text) ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
              : ''
          } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    matressPocketsD.innerHTML = matressPocketsDtext.join('');
  }
  if (ottomanBoxD) {
    // * HTML created for ottomanBox
    var ottomanBoxDtext = ottomanBox.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item ottomanBox-opt ${bedOption.ottomanBox === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.ottomanBox === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.ottomanBox === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.ottomanBox === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.ottomanBox === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.ottomanBox === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    ottomanBoxD.innerHTML = ottomanBoxDtext.join('');
  }
  if (SSAssemblyD) {
    // * HTML created for SSAssembly
    var SSAssemblyDtext = SSAssembly.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item SSAssembly-opt ${bedOption.SSAssembly === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.SSAssembly === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.SSAssembly === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.SSAssembly === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.SSAssembly === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.SSAssembly === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    SSAssemblyD.innerHTML = SSAssemblyDtext.join('');
  }
  if (disposalD) {
    // * HTML created for disposal
    var disposalDtext = disposal.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item disposal-opt ${bedOption.disposal === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
         ${
           bedSize == '3FT'
             ? `<p class='price ${bedOption.disposal === item.text ? 'active' : ''}'>£ ${item.threeft == 0 ? ' 0.00' : +item.threeft} </p>`
             : ''
         }   
         ${
           bedSize == '4FT'
             ? `<p class='price ${bedOption.disposal === item.text ? 'active' : ''}'>£ ${item.fourft == 0 ? '0.00' : item.fourft}</p>`
             : ''
         }   
         ${
           bedSize == '4FT6'
             ? `<p class='price ${bedOption.disposal === item.text ? 'active' : ''}'>£ ${item.fourftSix == 0 ? '0.00' : item.fourftSix}</p>`
             : ''
         }   
         ${
           bedSize == '5FT'
             ? `<p class='price ${bedOption.disposal === item.text ? 'active' : ''}'>£ ${item.fiveft == 0 ? '0.00' : item.fiveft}</p>`
             : ''
         }   
         ${
           bedSize == '6FT'
             ? `<p class='price ${bedOption.disposal === item.text ? 'active' : ''}'>£ ${item.sixft == 0 ? '0.00' : item.sixft}</p>`
             : ''
         } 
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    disposalD.innerHTML = disposalDtext.join('');
  }
  if (deliveryD) {
    // * HTML created for delivery
    var deliveryDtext = delivery.map((item) => {
      return `<div onclick='hanldleSelectOption(this)' id=${item.text}     
        class='dropdown_item delivery-opt ${bedOption.delivery === item.text ? 'selected' : ''}'>      
        <img class='iconSize' src=${item.url} alt=''/>     
         <p>${item.text}</p>
        
        ${
          !item.inStock
            ? " <div class='outofStock'><img src='https://cdn.shopify.com/s/files/1/0518/2157/6345/t/19/assets/outOfStock.png' alt='' width='70'></div>"
            : ''
        }     
        </div>`;
    });
    deliveryD.innerHTML = deliveryDtext.join('');
  }
};

const setDelayD = (e) => {
  bedOption.delivery = e.target.value;
  localStorage.setItem('userSel', JSON.stringify({ bedOption, bedPrice }));
};
const handleDelayDelivery = () => {
  if (document.getElementById('datepickerDelaydelivery')) {
    return;
  } else {
    const date = document.createElement('div');
    date.setAttribute('class', 'w-100 ps-4');
    date.setAttribute('id', 'datequeryDelivery');
    date.innerHTML = `
    <div class="w-full flex">
     <div class="mw-stack__item">
                  <span class="mw-text mw-text--style-strong">DELAY MY DELIVERY UNTIL AFTER</span>&nbsp;<span class="mw-text mw-text--style-negative">*</span>
                </div>
                <div class="mw-option__value calender">
            <input placeholder="Select your date" type="text" id="datepickerDelaydelivery" onchange="setDelayD(event)" value="" class="calendar">
            <i class="fas fa-calendar-check icon"></i>
          </div>
      
    </div>
  `;
    document.getElementById('deliveryM')?.appendChild(date);
    jQuery(document).ready(function () {
      jQuery('#datepickerDelaydelivery').datepicker({
        dateFormat: 'dd/mm/yy',
        startDate: '+1d',
      });
    });
  }
};

// todo This function is created for select the option in user interface
const hanldleSelectOption = (ele) => {
  if (ele.children[3]) {
    return;
  }
  // TODO to make border on selected option
  ele.classList.add('selected');
  let price;
  className = ele.classList;
  //TODO ends here

  // TODO to remove border on unselected option
  var parent = ele.parentNode;
  for (var i = 0; i < parent.children.length; i++) {
    var child = parent.children[i];
    if (child !== ele) {
      for (let i = 0; i < ele.children.length; i++) {
        if (ele.children[i]) {
          if (child.children[i]?.classList.contains('price')) {
            ele.children[i].classList.add('active');
            price = parseFloat(ele.children[i].innerHTML.split('£')[1]);
            if (isNaN(price)) {
              price = 0;
            }
            child.children[i].classList.remove('active');
          }
        }
      }
      child.classList.remove('selected');
    }
  }
  //TODO ends here

  // TODO to change the value of selected option
  const value = ele.children[1].innerHTML;

  if (className.contains('bedFrameShape')) {
    if (className.contains('bedFrameShape' && 'headboard')) {
      document.getElementById('bedFrameShape-headboard').innerHTML = value;
      bedOption.bedFrameShape.hb = value;
      bedPrice.bedFrameShape.hb = price;
    } else if (className.contains('bedFrameShape' && 'footboard')) {
      const foot = document.getElementById('bedFrameShape-footboard');
      foot.innerHTML = value;
      bedPrice.bedFrameShape.fb = price;
      bedOption.bedFrameShape.fb = value;
    }
  } else if (className.contains('upholstery')) {
    if (className.contains('upholstery' && 'headboard')) {
      const head = document.getElementById('upholsteryHeadboard');
      head.innerHTML = value;
      bedOption.upholestery.hb = value;
      bedPrice.upholestery.hb = price;
    } else if (className.contains('upholstery' && 'footboard')) {
      const foot = document.getElementById('upholsteryFootboard');
      foot.innerHTML = value;
      bedOption.upholestery.fb = value;
      bedPrice.upholestery.fb = price;
    }
    viewupholestery();
  } else if (className.contains('feature-opt')) {
    if (className.contains('feature-opt' && 'wings')) {
      let wingbeading = document.getElementById('wing_beading');
      const head = document.getElementById('HeadboardWings');
      const wbt = document.getElementById('beading-wing-content');

      if (value === 'None') {
        wingbeading.classList.remove('d-flex');
        wingbeading.classList.add('d-none');
        wbt.parentElement.classList.remove('d-flex');
        wbt.parentElement.classList.add('d-none');
        wbt.children[2].classList.remove('active');
        wbt.classList.remove('selected');
        document.getElementById('wing-text').classList.add('d-none');
        document.getElementById('wing-text').classList.remove('d-flex');
        bedOption.additionFeature.wing_beading = '';
        bedPrice.additionFeature.wing_beading = 0;
      } else {
        wingbeading.classList.add('d-flex');
        wingbeading.classList.remove('d-none');
      }
      head.innerHTML = value;
      bedOption.additionFeature.wings = value;
      bedPrice.additionFeature.wings = price;
    } else if (className.contains('feature-opt' && 'bumper')) {
      const foot = document.getElementById('HeadboardBumper');
      let bumperbeading = document.getElementById('bumper_beading');
      foot.innerHTML = value;
      const wbt = document.getElementById('beading-bumper-content');
      if (value === 'None') {
        bedOption.additionFeature.bumper_beading = '';
        bedPrice.additionFeature.bumper_beading = 0;
        bumperbeading.classList.remove('d-flex');
        bumperbeading.classList.add('d-none');
        wbt.parentElement.classList.remove('d-flex');
        wbt.parentElement.classList.add('d-none');
        wbt.children[2].classList.remove('active');
        wbt.classList.remove('selected');
        document.getElementById('bumper-text').classList.add('d-none');
        document.getElementById('bumper-text').classList.remove('d-flex');
      } else {
        bumperbeading.classList.add('d-flex');
        bumperbeading.classList.remove('d-none');
      }
      bedOption.additionFeature.bumper = value;
      bedPrice.additionFeature.bumper = price;
    }
  } else if (className.contains('material-opt')) {
    let val = `${ele.id.split('color')[0]}-${value}`;
    bedOption.material = val;
    bedPrice.material = price;
    document.getElementById('material').innerHTML = val;
    let opt = document.querySelectorAll('.material-opt');
    for (var i = 0; i < opt.length; i++) {
      var child = opt[i];
      if (child !== ele) {
        child.children[2].classList.remove('active');
        child.classList.remove('selected');
      }
    }
  } else if (className.contains('pholestery')) {
    const head = document.getElementById('PholsteryFinish');
    head.innerHTML = value;
    bedOption.pholesteryFinish = value;
    bedPrice.pholesteryFinish = price;
  } else if (className.contains('headboardHeight')) {
    const head = document.getElementById('headboardHeight');
    head.innerHTML = value;
    bedOption.headboardHeight = value;
    bedPrice.headboardHeight = price;
  } else if (className.contains('footboardHeight')) {
    document.getElementById('footboardHeight').innerHTML = value;
    bedOption.footboardHeight = value;
    bedPrice.footboardHeight = price;
  } else if (className.contains('legs-opt')) {
    document.getElementById('legs').innerHTML = value;
    bedOption.legs = value;
    bedPrice.legs = price;
  } else if (className.contains('storage-opt')) {
    document.getElementById('frameSupport').innerHTML = value;
    bedOption.frameSupport = value;
    bedPrice.frameSupport = price;
  } else if (className.contains('underBedLowerFloor-opt')) {
    document.getElementById('underBedLowerFloor').innerHTML = value;
    bedOption.underBedLowerFloor = value;
    bedPrice.underBedLowerFloor = price;
  } else if (className.contains('mattress-opt') || className.contains('pockets-opt')) {
    const mat = document.getElementById('mattress');
    if (value === 'Orthopaedic Memory') {
      mat.innerHTML = value;
      bedOption.mattress = value;
      bedPrice.mattress = price;
      document.getElementById('pockets').style.display = 'none';
    } else if (value == 'Not Required') {
      mat.innerHTML = value;
      bedOption.mattress = value;
      bedPrice.mattress = price;
      document.getElementById('pockets').style.display = 'none';
    } else {
      document.getElementById('pockets').style.display = 'flex';

      if (className.contains('pockets-opt')) {
        let val = mat.innerHTML.split('-')[0];
        mat.innerHTML = `${val}-${value}`;
        bedOption.mattress = `${val}-${value}`;
        bedOption.matressPockets = value;
        bedPrice.matressPockets = price;
        handlePrice();
      } else {
        bedOption.mattress = value;
        bedPrice.mattress = price;
        let pci = mat.innerHTML.includes('-');
        if (pci) {
          let val = '1000';
          mat.innerHTML = `${value}-${val}`;
          bedOption.matressPockets = '1000 Pockets';
          handleview();
        } else {
          mat.innerHTML = `${value}`;
        }
        handlePrice();
      }
    }
  } else if (className.contains('ottomanBox-opt')) {
    document.getElementById('ottomanBox').innerHTML = value;
    bedOption.ottomanBox = value;
    bedPrice.ottomanBox = price;
  } else if (className.contains('SSAssembly-opt')) {
    document.getElementById('SSAssembly').innerHTML = value;
    bedOption.SSAssembly = value;
    bedPrice.SSAssembly = price;
  } else if (className.contains('disposal-opt')) {
    document.getElementById('disposal').innerHTML = value;
    bedOption.disposal = value;
    bedPrice.disposal = price;
  } else if (className.contains('delivery-opt')) {
    document.getElementById('delivery').innerHTML = value;
    bedOption.delivery = value;
    bedPrice.delivery = price;
  }
  handlePrice();
  handleQuery(ele);
  if (value == 'Delay My Delivery Until After') {
    handleDelayDelivery();
  } else if (value == 'Deliver As Soon As Possible') {
    var parentElement = document.getElementById('deliveryM');

    var elementToRemove = document.getElementById('datequeryDelivery');

    // Check if the element to remove exists before attempting to remove it
    if (elementToRemove) {
      // Remove the element from its parent
      parentElement.removeChild(elementToRemove);
    }
  }
  localStorage.setItem('userSel', JSON.stringify({ bedOption, bedPrice }));
};

window.onload = () => {
  checkBedSize();
  handleview();

  document.getElementById('selectedBedSize').innerText = intbedSize;
  const out = document.querySelectorAll('.outofStock');
  for (let i = 0; i < out.length; i++) {}
  setPrevalue();
};
let setPrevalue = () => {
  let config = localStorage.getItem('userSel');
  if (config) {
    document.getElementById('bedFrameShape-headboard').innerText = bedOption.bedFrameShape.hb;
    document.getElementById('bedFrameShape-footboard').innerText = bedOption.bedFrameShape.fb;
    document.getElementById('upholsteryHeadboard').innerText = bedOption.upholestery.hb;
    document.getElementById('upholsteryFootboard').innerText = bedOption.upholestery.fb;
    document.getElementById('HeadboardWings').innerText = bedOption.additionFeature.wings;
    document.getElementById('HeadboardBumper').innerText = bedOption.additionFeature.bumper;
    document.getElementById('material').innerText = bedOption.material;
    document.getElementById('headboardHeight').innerText = bedOption.headboardHeight;
    document.getElementById('footboardHeight').innerText = bedOption.footboardHeight;
    document.getElementById('legs').innerText = bedOption.legs;
    document.getElementById('frameSupport').innerText = bedOption.frameSupport;
    document.getElementById('underBedLowerFloor').innerText = bedOption.underBedLowerFloor;
    document.getElementById('mattress').innerText = bedOption.mattress;
    document.getElementById('ottomanBox').innerText = bedOption.ottomanBox;
    document.getElementById('SSAssembly').innerText = bedOption.SSAssembly;
    document.getElementById('disposal').innerText = bedOption.disposal;
    document.getElementById('delivery').innerText = bedOption.delivery;
  }
  if (bedOption.delivery?.includes('/')) {
    handleDelayDelivery();
    document.getElementById('datepickerDelaydelivery').value = bedOption.delivery;
    $('#Delay').addClass('selected');
  }
  if (bedOption.additionFeature.wing_beading) {
    const wbt = document.getElementById('beading-wing-content');
    wbt.classList.add('selected');
    wbt.children[2].classList.add('active');
    wbt.parentElement.classList.remove('d-none');
    wbt.parentElement.classList.add('d-flex');
    document.getElementById('wing-text').classList.remove('d-none');
    document.getElementById('wing-text').classList.add('d-flex');
  }
  if (bedOption.additionFeature.bumper_beading) {
    const wbt = document.getElementById('beading-bumper-content');
    wbt.classList.add('selected');
    wbt.children[2].classList.add('active');
    wbt.parentElement.classList.remove('d-none');
    wbt.parentElement.classList.add('d-flex');
    document.getElementById('bumper-text').classList.remove('d-none');
    document.getElementById('bumper-text').classList.add('d-flex');
  }
  if (bedOption.mattress.includes('Luxury Pocket') || bedOption.mattress.includes('Premium Pocket') || bedOption.mattress.includes('Memory Pocket')) {
    document.getElementById('pockets').style.display = 'flex';
    return;
  } else {
    document.getElementById('pockets').style.display = 'none';
  }
};
const handlebedChange = () => {
  const sel = document.getElementById('changeselect').value;
  localStorage.setItem('bed-size', sel);
  checkBedSize();
  handleview();
  document.getElementById('selectedBedSize').innerText = intbedSize === null ? '3FT' : intbedSize;
};

const DefaultSelection = () => {
  //let bs = localStorage.getItem("bed-size");
  localStorage.removeItem('userSel');
  localStorage.removeItem('3dc');
  window.location.reload();
  //localStorage.setItem("bed-size", bs);
};
const hideDisclamer = () => {
  document.getElementById('disclaimer').style.display = 'none';
};
